import { DateTimeType, PlainDateType } from './dateTypes';
import { OtherString } from './otherString';
import { ReceiptFile } from './receiptFile';
import { ReceiptItem } from './receiptItem';
import { ReceiptType } from './receiptType';
import { z } from 'zod';

export const MealParticipant = z.object({
    /** Participant name */
    name: z.string().nullish(),
    /** Paricipant company */
    company: z.string().nullish(),
    /** External/internal */
    external: z.boolean().nullish(),
});
export type MealParticipant = z.infer<typeof MealParticipant>;

export const ReceiptDraftMetaExtraction = z.object({
    extractedInformationId: z.string(),
    modifiedOn: DateTimeType,
});

export const ReceiptDraftMetaConflict = z.object({
    extractedInformationId: z.string(),
    value: z.unknown(),
});
export type ReceiptDraftMetaConflict = z.infer<typeof ReceiptDraftMetaConflict>;

export const ReceiptDraftMeta = z.object({
    source: z.enum(['extraction', 'manual', 'mcp']),
    extractedInformation: ReceiptDraftMetaExtraction.nullish(),
    /** Extracted value that differs from the value entered by the user; open until dismissed */
    conflict: ReceiptDraftMetaConflict.nullish(),
});

export type ReceiptDraftMeta = z.infer<typeof ReceiptDraftMeta>;

export const ReceiptDraft = z.object({
    /** Receipt description */
    description: z.string().nullish(),
    /** date of the receipt */
    date: PlainDateType.nullish(),
    /** Values e.g. DE */
    countryCode: z.string().nullish(),
    /** The receipt's type */
    type: ReceiptType.or(OtherString).nullish(),
    /** Receipt items. Can be multiple if receipt contains different tax rates */
    items: z.array(ReceiptItem).nullish(),
    /** If type == 'meal', the participants */
    mealParticipants: z.array(MealParticipant).nullish(),
    /** Meta information about the receipt draft, e.g. if it was created by extraction and if the extracted information was accepted by the user */
    meta: z.record(z.string(), ReceiptDraftMeta).nullish(),
});

export type ReceiptDraft = z.infer<typeof ReceiptDraft>;

export const ReceiptSlim = ReceiptDraft.omit({ meta: true }).extend({
    id: z.string(),
    files: z.array(ReceiptFile).nullish(),
});
export type ReceiptSlim = z.infer<typeof ReceiptSlim>;
